import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeoplePersonRoute extends Route {
  @service store;
  @service router;

  model({ person_id }) {
    return this.store.findRecord('person', person_id);
  }

  @action
  error(error) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('resources.people.active');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(ResourcesPeoplePersonRoute);
